(function () {
  if (document.getElementById('pk-samtykke-css')) return;
  var css = document.createElement('style');
  css.id = 'pk-samtykke-css';
  css.textContent = [
    /* Cookie-banneret ligger altid øverst, også over app-knapper og mobilmenuen */
    'cookie-banner .cookie-banner { z-index: 2147483000; }',
    /* Shopifys eget standardbanner skjules, så kun Palmekongens banner vises. Indstillingen i Shopify bevares, så samtykke stadig kræves i Danmark */
    '#shopify-pc__banner, #shopify-pc__prefs { display: none !important; }',
    /* Omnisends faste rabatknap nederst på siden vises aldrig (passer ikke til brandet) */
    '[class*="omnisend-form-"][class*="-teaser"] { display: none !important; }',
    /* Mens banneret er åbent, skjules også Omnisend-popups, så intet dækker for valget */
    'html.pk-samtykke-aaben #omnisend-forms-wrapper { display: none !important; }',
    '@media screen and (max-width: 749px) {',
    '  cookie-banner .cookie__card { padding: 2rem 1.6rem calc(2rem + env(safe-area-inset-bottom)); }',
    '  cookie-banner .cookie__content > * + * { margin-top: 1rem; }',
    '  cookie-banner .cookie__card > * + .cookie__buttons { margin-top: 1.6rem; }',
    '  cookie-banner .cookie__buttons { flex-wrap: nowrap; }',
    '  cookie-banner .cookie__buttons .button, cookie-banner .cookie__buttons .button:first-child { flex: 1 1 0; min-height: 4.8rem; }',
    '}'
  ].join('\n');
  document.head.appendChild(css);
})();

/* Husker kundens valg i et nødvendigt cookie, så banneret ikke kommer igen på hver side (180 dage) */
var PK_VALG_COOKIE = 'pk_cookievalg';
function pkHarValgt() {
  return document.cookie.split('; ').some(function (c) { return c.indexOf(PK_VALG_COOKIE + '=') === 0; });
}
function pkGemValg(vaerdi) {
  document.cookie = PK_VALG_COOKIE + '=' + vaerdi + '; max-age=' + (60 * 60 * 24 * 180) + '; path=/; SameSite=Lax' + (location.protocol === 'https:' ? '; Secure' : '');
}

class CookieBanner extends HTMLElement {
  constructor() {
    super();

    this.classes = {
      activeClass: 'is-active',
      closingClass: 'is-closing'
    };
    this.banner = this.querySelector('.cookie-banner');

    if (this.dataset.testMode === 'true') {
      this.init();

      this.querySelectorAll('.button').forEach(
        (button) => button.addEventListener('click', this.close.bind(this))
      );
    }
    else {
      window.Shopify.loadFeatures([
        {
          name: 'consent-tracking-api',
          version: '0.1',
        }
      ],
      (error) => {
        if (error) {
          throw error;
        }
    
        this.beforeInit();
      });
    }
  }

  connectedCallback() {
    if (Shopify.designMode) {
      this.onShopifySectionLoad = this.onSectionLoad.bind(this);
      this.onShopifySectionSelect = this.onSectionSelect.bind(this);
      this.onShopifySectionDeselect = this.onSectionDeselect.bind(this);
      document.addEventListener('shopify:section:load', this.onShopifySectionLoad);
      document.addEventListener('shopify:section:select', this.onShopifySectionSelect);
      document.addEventListener('shopify:section:deselect', this.onShopifySectionDeselect);
    }
  }
  disconnectedCallback() {
    if (Shopify.designMode) {
      document.removeEventListener('shopify:section:load', this.onShopifySectionLoad);
      document.removeEventListener('shopify:section:select', this.onShopifySectionSelect);
      document.removeEventListener('shopify:section:deselect', this.onShopifySectionDeselect);
    }
  }
  onSectionLoad(event) {
    filterShopifyEvent(event, this, () => this.open.bind(this));
  }
  onSectionSelect(event) {
    filterShopifyEvent(event, this, this.open.bind(this));
  }
  onSectionDeselect(event) {
    filterShopifyEvent(event, this, this.close.bind(this));
  }

  beforeInit() {
    const privacy = window.Shopify.customerPrivacy;
    const onCart = window.location.pathname.match(/^(\/[a-z]{2}(-[A-Z]{2})?)?\/cart$/);

    /* Har kunden allerede accepteret hos Shopify, eller valgt i vores banner, vises det ikke igen */
    let alleredeAccepteret = false;
    try {
      const v = typeof privacy.currentVisitorConsent === 'function' ? privacy.currentVisitorConsent() : null;
      alleredeAccepteret = !!v && (v.analytics === 'yes' || v.marketing === 'yes' || v.preferences === 'yes');
    } catch (e) {}

    let regionKraeverSamtykke;
    if (typeof privacy.shouldShowBanner === 'function') {
      regionKraeverSamtykke = privacy.shouldShowBanner();
    } else {
      regionKraeverSamtykke = !privacy.userCanBeTracked() && privacy.getTrackingConsent() === 'no_interaction';
    }

    const needsBanner = regionKraeverSamtykke && !pkHarValgt() && !alleredeAccepteret;

    if (!onCart && needsBanner) {
      document.documentElement.classList.add('pk-samtykke-aaben');
      this.init();

      this.querySelectorAll('.button').forEach(
        (button) => button.addEventListener('click', this.onButtonClick.bind(this))
      );
    }
  }

  init() {
    if (Shopify && Shopify.designMode) {
      return;
    }

    setTimeout(function() {
      this.open();
    }.bind(this), parseInt(this.dataset.delay) * 1000);
  }

  open() {
    document.documentElement.classList.add('pk-samtykke-aaben');
    this.banner.classList.add(this.classes.activeClass);
  }

  close() {
    this.banner.classList.add(this.classes.closingClass);

    setTimeout(() => {
      this.banner.classList.remove(this.classes.activeClass);
      this.banner.classList.remove(this.classes.closingClass);
      document.documentElement.classList.remove('pk-samtykke-aaben');
    }, 500);
  }

  onButtonClick(event) {
    event.preventDefault();
    this.close();

    const granted = event.target.closest('button').name === 'accept';
    pkGemValg(granted ? 'ja' : 'nej');
    window.Shopify.customerPrivacy.setTrackingConsent(
      {
        "analytics": granted,
        "marketing": granted,
        "preferences": granted
      },
      this.noop
    );
  }

  noop() {
  }
}
customElements.define('cookie-banner', CookieBanner);
